import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ assetInventoryId = '', ...params }) => {
  return await dponetAPI.get(`/asset_inventories/${assetInventoryId}`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/asset_inventories', { assetInventory: data })
}

const update = async ({ assetInventoryId = '', ...data }) => {
  return await dponetAPI.patch(`/asset_inventories/${assetInventoryId}`, {
    assetInventory: data,
  })
}

const destroy = async ({ assetInventoryId = '' }) => {
  return await dponetAPI.delete(`/asset_inventories/${assetInventoryId}`)
}

const report = async () => {
  return await dponetAPI.get('/asset_inventories/export')
}

export default {
  get,
  create,
  update,
  destroy,
  report,
}
